// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"e173e22a","458":"0b719d28","824":"6450624e","954":"f4cb1674"}[chunkId] + ".chunk.js";
};